// extracted by mini-css-extract-plugin
export default {"Index":"Index_Index__PkVdb"};